export const ContactTypes = {
	SET_CONTACT_FILTER_USER_TOUCH: "SET_CONTACT_FILTER_USER_TOUCH",
	SET_CONTACT_FILTER_GROUP_TOUCH: "SET_CONTACT_FILTER_GROUP_TOUCH",
}
